<app-loading *ngIf="contentReady"></app-loading>

<section class="bb-page">
  <div class="bb-page-shell">

    <!-- HEADER -->
    <div class="bb-page-header">
      <div class="bb-page-title-block">
        <span class="bb-eyebrow">{{ 'مبيعات الموظفين' | transloco }}</span>
        <h2 class="bb-page-title">{{ 'مبيعات الموظفين' | transloco }}</h2>
        <p class="bb-page-subtitle">{{ 'الموظف' | transloco }}</p>
      </div>

      <div class="bb-header-actions noPrint">
        <button class="bb-btn bb-btn-secondary" onclick="window.print()">
          {{ 'Print' | transloco }}
        </button>
      </div>
    </div>

    <!-- FILTERS -->
    <div class="bb-filter-card noPrint">
      <div class="row g-3">

        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="bb-field">
            <label class="bb-label">{{ 'الموظف' | transloco }}</label>
            <div class="bb-select-wrap">
              <select class="bb-select" [(ngModel)]="herosd" (change)="filterAllHeros()">
                <option *ngFor="let hero of AllHeros" [value]="hero.id">
                  {{ hero.first_name }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="bb-field">
            <label class="bb-label">{{ 'اليوم' | transloco }}</label>

            <div class="bb-booking-calendar-field" [dir]="isAr ? 'rtl' : 'ltr'">
              <button
                type="button"
                class="bb-booking-calendar-trigger"
                (click)="toggleDayCalendar()"
                [ngClass]="{
                  'is-valid': date
                }"
              >
                <span>{{ getDayDisplay() }}</span>
                <i class="fa-solid fa-calendar-days"></i>
              </button>

              @if(showDayCalendar) {
              <div class="bb-booking-calendar-panel">
                <div class="bb-booking-calendar-head">
                  <button type="button" (click)="previousDayCalendarMonth()">
                    <i class="fa-solid" [ngClass]="isAr ? 'fa-chevron-right' : 'fa-chevron-left'"></i>
                  </button>

                  <strong>{{ getDayCalendarTitle() }}</strong>

                  <button type="button" (click)="nextDayCalendarMonth()">
                    <i class="fa-solid" [ngClass]="isAr ? 'fa-chevron-left' : 'fa-chevron-right'"></i>
                  </button>
                </div>

                <div class="bb-booking-calendar-weekdays">
                  @for(dayName of getDayCalendarWeekDays(); track dayName) {
                  <span>{{ dayName }}</span>
                  }
                </div>

                <div class="bb-booking-calendar-grid">
                  @for(calendarDay of getDayCalendarDays(); track calendarDay.date.getTime()) {
                  <button
                    type="button"
                    class="bb-booking-calendar-day"
                    [class.other-month]="!calendarDay.isCurrentMonth"
                    [class.today]="calendarDay.isToday"
                    [class.selected]="calendarDay.isSelected"
                    [disabled]="calendarDay.isDisabled"
                    (click)="selectDayCalendarDate(calendarDay.date)"
                  >
                    {{ calendarDay.dayNumber }}
                  </button>
                  }
                </div>
              </div>
              }
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="bb-field">
            <label class="bb-label">{{ 'الشهر' | transloco }}</label>
            <div class="bb-select-wrap">
              <select class="bb-select" [(ngModel)]="selectedMonth" (change)="getByMonth()">
                <option value="">{{ '-- اختر الشهر --' | transloco }}</option>
                <option *ngFor="let month of months" [value]="month.value">
                  {{ isAr ? month.name_ar : month.name_en }}
                </option>
              </select>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- SUMMARY -->
    <div class="finance-summary-grid">

      <div class="finance-summary-card finance-summary-card-net">
        <div class="finance-summary-card-head">
          <h6>{{ 'إجمالي المبيعات' | transloco }}</h6>
        </div>
        <h3 class="finance-value-success">
          {{ totalCollected | number:'1.2-2' }} {{ 'EGP' | transloco }}
        </h3>
      </div>

      <div class="finance-summary-card">
        <div class="finance-summary-card-head">
          <h6>{{ 'عدد العمليات' | transloco }}</h6>
        </div>
        <h3 class="bb-text-navy">
          {{ totalCount }}
        </h3>
      </div>

    </div>

    <!-- TABLE -->
    <div class="finance-tables-grid">

      <div class="finance-table-card finance-table-full">

        <div class="bb-empty-state" *ngIf="hasData">
          <app-nodata></app-nodata>
        </div>

        <div class="finance-table-scroll" *ngIf="!hasData">
          <table class="finance-table">
            <thead>
              <tr>
                <th>{{ 'المبلغ' | transloco }}</th>
                <th>{{ 'الأوردر' | transloco }}</th>
                <th>{{ 'التاريخ' | transloco }}</th>
                <th>{{ 'المخزن' | transloco }}</th>
                <th class="finance-actions-cell noPrint"></th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let value of collectedFromDH">

                <td [attr.data-label]="'المبلغ'">
                  <span class="finance-main-text finance-value-success">
                    {{ value.sales }} {{ 'EGP' | transloco }}
                  </span>
                </td>

                <td [attr.data-label]="'الأوردر'">
                  {{ value.order_id }}
                </td>

                <td [attr.data-label]="'التاريخ'">
                  {{ value.created_at | date:'short' }}
                </td>

                <td [attr.data-label]="'المخزن'">
                  {{ value.warehouse?.name }}
                </td>

                <td class="finance-actions-cell noPrint" [attr.data-label]="'حذف'">
                  <button (click)="delete(value.id)" class="finance-delete-btn">
                    <i class="fa-solid fa-xmark"></i>
                  </button>
                </td>

              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="bb-paginator bb-flex bb-items-center bb-justify-center bb-gap-12 bb-p-12 noPrint" *ngIf="lastPage > 1">

          <button
            class="bb-btn bb-btn-secondary bb-btn-sm"
            [disabled]="currentPage === 1"
            (click)="changePage(currentPage - 1)"
          >
            {{ 'Prev' | transloco }}
          </button>

          <span class="bb-font-bold bb-text-navy">
            {{ 'Page' | transloco }} {{ currentPage }} {{ 'of' | transloco }} {{ lastPage }}
          </span>

          <button
            class="bb-btn bb-btn-secondary bb-btn-sm"
            [disabled]="currentPage === lastPage"
            (click)="changePage(currentPage + 1)"
          >
            {{ 'Next' | transloco }}
          </button>

        </div>

      </div>

    </div>

  </div>
</section>